import { IAutosaveNotificationResponse } from "../Interfaces";

export function GetAutoSaveRedirectUrl(autoSave: IAutosaveNotificationResponse) {
  let redirectUrl = '';
  switch (autoSave.importProcessId) {
    case 1:
      redirectUrl = `/DataImport/Import?autosaveId=${autoSave.id}`;
      break;
    case 2:
    case 6:
      redirectUrl = `/DataImport/DueDiligenceImport?autosaveId=${autoSave.id}`;
      break;
    case 3:
      redirectUrl = `/DataImport/PriceImport?autosaveId=${autoSave.id}`;
      break;
    case 5:
      redirectUrl = `/DataImport/ServicingDataImport?autosaveId=${autoSave.id}`;
      break;
    default:
      $log('Unrecognized Import Process Id');
      break;
  }

  return redirectUrl;
}

export const stepMappings: Record<any, any> = {
  transaction: 'Transaction',
  process: 'Process',
  sourcefile: 'Source File',
  rawdata: 'Raw Data',
  sourcecompare: 'Source Compare',
  mapping: 'Mapping',
  enummapping: 'Enum Mapping',
  datapreview: 'Data Preview',
  import: 'Import',
  enrichment: 'Enrichment',
  validation: 'Validation',
  importenricheddata: 'Import Enriched Data',
  alternatecompare: 'Alternate Compare',
  matching: 'Matched Loans',
  priceselection: 'Price Selection',
  priceimport: 'Price Import',
  selectservicer: 'Select Servicer',
  reviewtype: 'Review Type',
  duediligenceimportstep: 'DD Import',
  bpoimportstep: 'BPO Import',
  servicingdataimportstep: 'Servicing Data Import',
  pricingimportstep: 'Price Import',
};

export function GetStepOverrides(step: string, importProcessId: number) {
  step = step.replaceAll('-', '');
  if (step === 'process') {
    if (importProcessId === 2) {
      step = 'reviewtype';
    }
    if (importProcessId === 3) {
      step = 'priceselection';
    }
    if (importProcessId === 5) {
      step = 'selectservicer';
    }
  }

  if (step === 'duediligenceimportstep') {
    if (importProcessId === 6) {
      step = 'bpoimportstep';
    }
  }

  return stepMappings[step.replaceAll('-', '')] ?? step;
}
